import { render, staticRenderFns } from "./color-interior-list-item.vue?vue&type=template&id=d09e189c&scoped=true"
import script from "./color-interior-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-interior-list-item.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./color-interior-list-item.vue?vue&type=style&index=0&id=d09e189c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09e189c",
  null
  
)

export default component.exports